export default "__VITE_ASSET__BtnXrqM6__"